<template>
  <div>

    <!-- <b-button v-b-modal.modal-center variant="success">Nouvelle Tâche</b-button> -->
    <b-modal id="modal-center" centered title="Ajouter une tâche">
        <form v-bind:class="classList" v-on:submit.prevent="createTaskInSection">
            <b-form-group
              id="patients-group"
              :label="$t('message.nomPatient')"
              label-for="patients"
            >
              <div>
                <b-form-input list="my-list-id" v-model="keyword"></b-form-input>
                <datalist id="my-list-id">
                  <option disabled>Rechercher patient</option>
                  <option v-for="patient in Patients" :key="patient.id">
                    {{ getDisplayName(patient) }}
                  </option>
                </datalist>
              </div>
            </b-form-group>
            <b-form-select
              v-model="selected"
              :options="missions"
              value-field="id"
              text-field="description_fr"
              size="sm"
              class="mt-3"
            ></b-form-select>
        </form>
        <template #modal-footer>
              <div class="w-100">
                <p class="float-left"></p>
                <b-button
                  variant="primary"
                  size="sm"
                  class="float-right"
                  @click="createTaskInSection"
                >
                  Créé
                </b-button>
              </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import AppConfig from "../../constants/AppConfig";
import axios from "axios";
import { mapGetters } from 'vuex'

export default {
  components: {},
  computed: {
    ...mapGetters(['amaActivites']),
    classList() {
      let classList = [];
      if (this.isActive) {
        classList.push("active");
      }
      return classList;
    },
    contentExists() {
      return this.content.length > 0;
    },

  },
  data() {
    return {
      keyword: null,
      patient: null,
      Patients: [],
      missions: [],
      content: "",
      isActive: false,
      selected: null,
      form: {
        dossier_medical_id: null,
      },
    };
  },
  watch: {
    keyword(after, before) {
      //
      if(before.length>=3){
        this.getResults();
      }
    },
  },
  methods: {
    createTaskInSection() {
      let self = this;
     let i =_.filter( this.missions,function(item){
       return item.id === self.selected;
      })
      let t = {
        activites_ama:i[0],
        patient: this.patient
      }
      this.$store.dispatch('createTask', { args: t })
      this.amaActivites[0].tasks.push(t);
    },
    getResults() {
     // if(this.keyword.lenght>3){
        axios
          .get(AppConfig.apiUrl + "/livesearch", {
            params: { keyword: this.keyword },
          })
          .then((res) => (this.Patients = res.data))
          .catch((error) => {window.console.log(error)});
      //}
    },
    getDisplayName(patient) {
      this.patient =patient;
      return patient.nom + " " + patient.prenom;
    },

    getGroupeActivites: function () {
      axios
        .get(AppConfig.apiUrl + "/mission/list")
        .then((res) => (this.missions = res.data.activites))
        .catch((error) => {window.console.log(error)});
    },
  },
  mounted() {
    this.getGroupeActivites();
  },
};
</script>
<style>
#modal-scoped___BV_modal_backdrop_{
  display: none !important;
}
.modal-backdrop{
  display: none !important;
}
</style>